'use client';

import Error from '@components/GeneralError';

export default Error;
